/*
 * Adelantar la primera foto de cada pantalla.
 *
 * Medido con Lighthouse: de los 2,3 s de LCP de la portada, 1,28 s son "Load
 * Delay" --el rato entre que llega el HTML y el navegador empieza a bajar la
 * foto grande--. Bajarla solo cuesta 517 ms. El retraso es que su URL no
 * existe hasta HTML -> bundle -> consulta -> render: `fetchpriority="high"`
 * llega tarde porque prioriza una peticion que todavia no ha nacido.
 *
 * Asi que la recordamos. Cada pantalla apunta aqui la URL de su primera foto,
 * y el script en linea de `index.html` la lee y la pide antes de que el bundle
 * se descargue. En la primera visita no hay nada apuntado y no cambia nada; a
 * partir de la segunda la peticion sale a los pocos ms en vez de a los 1300.
 *
 * `localStorage` y no `sessionStorage` a proposito: lo segundo se vacia en
 * cada pestana nueva, que es justo cuando mas se nota.
 */

const PREFIJO = "lcp:";

/*
 * Dos casos quedan fuera, y por la misma razon: la primera foto no es la de
 * siempre, asi que adelantarla seria una peticion tirada. Un deep link a un
 * post concreto (`?post=`) y una busqueda (`?q=`). Al no leer ni escribir, esa
 * clave conserva lo que apunto la visita sin filtrar.
 */
export function clavePrimeraFoto(ruta: string, busqueda: string): string | null {
  const params = new URLSearchParams(busqueda);
  if (params.get("post") || params.get("q")) return null;
  const limpia = ruta.replace(/\/+$/, "") || "/";
  const vista = params.get("view");
  return `${PREFIJO}${limpia}${vista ? `?${vista}` : ""}`;
}

/*
 * El mismo filtro que aplica el script en linea antes de inyectar el preload:
 * `localStorage` lo escribe cualquier cosa que corra en el origen, asi que una
 * URL de otro sitio no se guarda ni se pide.
 */
export function urlDeFotoValida(url: string | null | undefined): boolean {
  return !!url && /^https:\/\/(images\.weserv\.nl|[a-z0-9-]+\.supabase\.co)\//.test(url);
}

export function recuerdaPrimeraFoto(url: string | null | undefined): void {
  if (!urlDeFotoValida(url)) return;
  try {
    const clave = clavePrimeraFoto(window.location.pathname, window.location.search);
    if (!clave) return;
    // Leer antes de escribir: la pantalla se repinta muchas veces y escribir
    // en localStorage es sincrono.
    if (window.localStorage.getItem(clave) !== url) window.localStorage.setItem(clave, url as string);
  } catch {
    /* modo incognito restringido, cuota llena: no es critico */
  }
}
